import { Content } from '@/types/content';

export const shouldPageBeHiddenFromIndexing = (pageData: Content): boolean => {
  const isEtikettPage = pageData.type === 'front' && pageData.data.publishedUrl.includes('etikett');
  const isHiddenFromLabrador = pageData.meta.seoDisableIndexing;
  const isHiddenEtikettPage = isEtikettPage && (pageData.data.counter || '') <= 5;

  return isHiddenFromLabrador || isHiddenEtikettPage;
};
